import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { NotificationPreferencesService } from '../../services/entities/notification-preferences.service';
import { ToastService } from '../../services/utils/toast.service';
import { NotificationPreferencesFormBase } from '../../components/master-detail-user-profile/notification-preferences-form.base';

/**
 * Preferenze notifiche come MODALE di primo avvio (prompt consenso). Stato e
 * logica di salvataggio sono condivisi con il pannello master-detail via
 * NotificationPreferencesFormBase; qui in più la chiusura del modale a fine save.
 */
@Component({
  selector: 'app-notification-preferences',
  templateUrl: './notification-preferences.page.html',
  styleUrls: ['./notification-preferences.page.scss'],
  standalone: false
})
export class NotificationPreferencesPage extends NotificationPreferencesFormBase implements OnInit {

  constructor(
    public modalCtrl: ModalController,
    notificationPreferencesService: NotificationPreferencesService,
    toast: ToastService,
    translate: TranslateService,
  ) {
    super(notificationPreferencesService, toast, translate);
  }

  async ngOnInit() {
    await this.loadPreferences();
  }

  async save() {
    if (await this.persistPreferences()) {
      await this.closeMe();
    }
  }

  async closeMe() {
    await this.modalCtrl.dismiss();
  }
}
